import { memo, useMemo } from 'react'
import type { FC } from 'react'
import type { NextPage, GetServerSidePropsContext } from 'next'
import styled from 'styled-components'
import { Layout, HeaderContents, SectionContents, SectionShop } from '@/components'
import { designGrid } from '@dy/commons/styles'
import { getTranslations } from '@/context'
import { mq } from '@dy/commons/styles'
import { HeadTag } from '@dy/commons/components'
import { initializeApollo, GET_PAGE, GET_LAYOUT } from '@/api'
import { CATEGORIES, BANNER, getLang, getAllCategories } from '@dy/commons/utils'
import { useRouter } from 'next/router'

type TypeContentsPage = {
  data: any,
  dataForProducts: any,
  layout?: any,
  user?: any
}



export async function getServerSideProps({ req, params, locale }: GetServerSidePropsContext) {
  const { slug } = params
  const dictionary = getTranslations(locale, ['shop', 'product_page'])
  const apolloClient = initializeApollo()
  const DYCustomerToken = req.cookies['DY_CUSTOMER_TOKEN']

  const queryContext = DYCustomerToken ? {
    isPrivatePath: true,
    DYCustomerToken
  } : { isPrivatePath: false }

  const { data:resPage } = await apolloClient.query({
    query: GET_PAGE,
    variables: {
      slug
    },
    context: queryContext
  })

  const { data:resLayout } = await apolloClient.query({
    query: GET_LAYOUT,
    variables: {
      bannerType: BANNER.SLIM,
      type: CATEGORIES.PRODUCT
    },
    context: queryContext
  })

  if (!resLayout || !resPage || !resPage?.page) return { notFound: true }

  let modals
  if(resLayout?.modals) modals = resLayout?.modals?.edges?.map(modal => modal.node)
  const arrayOfVariantNodes = Array.isArray(resPage?.page?.variants?.edges) ? resPage?.page?.variants?.edges.map(item => item.node) : []


  return {
    props: {
      data: resPage.page,
      dataForProducts: {categories: resPage.page.categories, variants: arrayOfVariantNodes },
      translations: dictionary,
      layout: {...resLayout, modals},
      initialApolloState: apolloClient.cache.extract()
    }
  }
}

// ORIGINAL
// const getContentsSections = (sections) => sections.map((section, idx) => {
//   return (
//     <SectionContents key={idx} section={section} />
//   )
// })
// CMS HACK
// added hack to simulate content with 2 rows ( not yet ready in the CMS)
const getContentsSections = (sections = []) => {
  let jumpIdx = null
  return sections.map((section, idx) => {

    if (jumpIdx && jumpIdx === idx) {
      jumpIdx = null
    } else {
      let columnsGrouped = null

      if(section.rows === 2) {
        jumpIdx = idx + 1
        const nextSectionColumns = sections[idx + 1]?.columns
        columnsGrouped = [...section.columns, ...nextSectionColumns]
      }

      return (
        <SectionContents key={idx} section={columnsGrouped ? { rows: section.rows, columns: columnsGrouped } : section} />
      )
    }
  })
}

const ContentsPage: NextPage<TypeContentsPage> & { Layout?:FC } = memo(({ data, dataForProducts }) => {
  const { title, subtitle, contents, seo, slug } = data
  const { locale:localeRouter } = useRouter()
  const locale = getLang(localeRouter)
  const allCategories = useMemo(()=> getAllCategories(slug, locale, dataForProducts.categories), [slug, locale, dataForProducts] )
  const ContentsSections = useMemo(() => getContentsSections(contents), [contents])
  return (
    <>
      <HeadTag seo={seo} jsonld={{ data, pageType: 'contents' }} slug={slug} pageType='contents' />
      <HeaderContents>
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
      </HeaderContents>
      <Main>
        {ContentsSections}
        {dataForProducts.variants.length > 0 && <SectionShop data={{variants: dataForProducts.variants, categories: allCategories}} pageCategory={`${slug?.[locale]}/category`}/>}
      </Main>
    </>
  )
})

ContentsPage.Layout = Layout
export default ContentsPage

const Main = styled.main`
  ${designGrid({ withoutGutter: true })}
  flex-grow: 2;
  overflow: hidden;
  position: relative;

  ${mq.greaterThan('tablet')} {
    overflow: unset;
  }

  ${mq.greaterThan('desktop-wide')} {
    margin: 0 auto;
    max-width: 1650px;
  }

  .marquee {
    ${mq.greaterThan('tablet')} {
      grid-column: 1 / span 12;
      left: calc(-50vw + 50%);
      position: relative;
      width: 100vw;
      width: 100dvw;
    }
  }
  .feria {
    display: flex;
    flex-direction: column;
    ${mq.greaterThan('tablet')} {
      flex-direction: row;
    }

    > a {
      background-image: unset;
      background-position: unset;
      background-repeat: unset;
      background-size: unset;
      position: unset;
      transition: unset;

      &:hover,
      &.active {
        background-size: unset;
      }
    }
  }
`
